import { SelectInputOption } from "@gx/dls/inputs/SelectInput";
import { SortBy, SortOrder } from "@gx/ts-contracts/shared/sorting_pb";

export const SORT_BY_CREATED_AT_OPTIONS: SelectInputOption[] = [
  {
    id: SortBy.CREATED_AT.toString(),
    label: "Created at",
    value: SortBy.CREATED_AT,
  },
];

export const SORT_BY_UPDATED_AT_OPTIONS: SelectInputOption[] = [
  {
    id: SortBy.UPDATED_AT.toString(),
    label: "Updated at",
    value: SortBy.UPDATED_AT,
  },
];

export const SORT_BY_NAME_OPTIONS: SelectInputOption[] = [
  {
    id: SortBy.NAME.toString(),
    label: "Name",
    value: SortBy.NAME,
  },
];

export const SORT_BY_OPTIONS: SelectInputOption[] = [
  ...SORT_BY_CREATED_AT_OPTIONS,
  ...SORT_BY_UPDATED_AT_OPTIONS,
  ...SORT_BY_NAME_OPTIONS,
];

export const SORT_ORDER_OPTIONS: SelectInputOption[] = [
  {
    id: SortOrder.ASC.toString(),
    label: "Ascending",
    value: SortOrder.ASC,
  },
  {
    id: SortOrder.DESC.toString(),
    label: "Descending",
    value: SortOrder.DESC,
  },
];
